export enum LoadingState {
    idle = "idle",
    loading = "loading",
    success = "success",
    failure = "failure",
}
